import { computed } from '@nuxtjs/composition-api';
import { useStore } from '~/composables/useStore';
import { generateFavoriteId } from '~/utils';
import { FavoriteType } from '~/types/common/user';
import { FavoriteTypes } from '~/enums';

export const useListFavorite = () => {
  const store = useStore();
  const authenticated = computed(() => store.state.auth.authenticated);

  const favoriteList = (type: FavoriteType) => {
    const { favoriteItems, favoriteProducers, favoriteArticles } = store.state.user.favorites;
    switch (type) {
      case FavoriteTypes.ITEM:
        return favoriteItems;
      case FavoriteTypes.PRODUCER:
        return favoriteProducers;
      case FavoriteTypes.ARTICLE:
        return favoriteArticles;
    }
    return [];
  };

  const fetchAllFavorites = (type: FavoriteType) => {
    if (!authenticated.value) return;
    if (favoriteList(type).length) return;
    store.dispatch('user/favorites/fetchAllFavorites', { favoriteType: type });
  };

  const checkIsFavorite = (code: string, type: FavoriteType) => {
    const favList = favoriteList(type);
    if (favList.length === 0) return false;
    const id = generateFavoriteId(type, code);
    return favList.some((fav) => fav.favoriteId === id);
  };

  return {
    fetchAllFavorites,
    checkIsFavorite,
  };
};
